export const environment = {
  production: true,
  apiUrl: 'https://saas.dev.helpingbot.ai/',
};
